import { useErrorHandler, useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';
import { ClientError, APIError } from 'shared-ui';
import { useState } from 'react';

import { useModalState } from 'hooks/useModalState/useModalState';
import { useMutation } from 'hooks/useMutation/useMutation';
import { updateTerminalSequence } from 'api/terminals/terminals';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

import { DeleteTerminal } from './DeleteTerminal';
import { DeleteTerminalContainerProps } from './DeleteTerminal.types';

export const DeleteTerminalContainer = ({ selectedTerminal }: DeleteTerminalContainerProps) => {
  const { isModalOpen, onModalClose, onModalOpen } = useModalState();
  const { formatMessage } = useLocale();
  const { handleError } = useErrorHandler();
  const queryClient = useQueryClient();

  const [cannotDelete, setCannotDelete] = useState(false);

  const { mutate: onUpdateTerminal, isLoading } = useMutation(updateTerminalSequence, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeyEnum.TERMINALS_WITH_SEQUENCE]);
      toast.dark(formatMessage({ id: AppMessages['definitions.sequences.delete.success'] }));
      onModalClose();
    },

    onError: (error: ClientError<APIError>) => {
      if (error.response?.data.code === 'aktywneSekwencje') {
        setCannotDelete(true);

        return;
      }

      handleError({ error });
    },
  });

  const onSubmit = () => {
    onUpdateTerminal({
      id: selectedTerminal.id,
      body: {
        sekwencja: null,
      },
    });
  };

  return (
    <DeleteTerminal
      isModalOpen={isModalOpen}
      onModalClose={() => {
        setCannotDelete(false);
        onModalClose();
      }}
      onModalOpen={onModalOpen}
      onSubmit={onSubmit}
      isLoading={isLoading}
      cannotDelete={cannotDelete}
    />
  );
};
